import { CircularProgress, Box } from "@mui/material";

const FullScreenLoader = () => (
  <Box
    sx={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backdropFilter: "blur(4px)",
      backgroundColor: "rgba(0,0,0,0.2)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 2000,
    }}
  >
    <CircularProgress size={60} color="primary" />
  </Box>
);

export default FullScreenLoader;
